import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbNavModule,
  NgbAccordionModule,
  NgbDropdownModule,
  NgbToastModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ComingSoonComponent } from '../_commonComponents/coming-soon/coming-soon.component';
import { ToastsContainer } from '../_commonComponents/toastComponent/toasts-container.component';
import { RecordPaymentComponent } from '../_commonComponents/record-payment/record-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisableWheelScrollDirective } from '../core/helpers/wheel.directive';

@NgModule({
  declarations: [
    ComingSoonComponent,
    ToastsContainer,
    RecordPaymentComponent,
    DisableWheelScrollDirective,
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbToastModule,
    FormsModule,
  ],
  exports: [
    ComingSoonComponent,
    ToastsContainer,
    RecordPaymentComponent,
    DisableWheelScrollDirective,
  ],
})
export class SharedModule {}
